import React from 'react'
import { object } from 'prop-types'
import moment from 'moment'
import { Icon, AttentionOutlined, Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Progress from 'Pods/Shared/Progress/Progress'

function Verification({ column = null }) {
  const {
    cgtVerificationAt,
    cgtVerificationPercentage,
    printReady,
    id,
  } = column || {}
  const pendingVerification = cgtVerificationPercentage === null
  const hasVerified = cgtVerificationPercentage !== null && cgtVerificationPercentage > 0
  const tooltipText = printReady
    ? 'CGTrader Quality Standard is not currently applicable for 3D Print Models.' : getTooltipText()

  function getTooltipText() {
    if (cgtVerificationPercentage === 0) {
      return (
        <span>
          This might be due to the model having too many polygons or using too many repeated objects. Try reducing
          the polygon count or converting repeated objects into instances. These are common issues, but there may
          be other factors as well. Ensure your model is clean, well-structured, and properly optimized.
        </span>
      )
    } else if (cgtVerificationPercentage > 0) {
      return (
        <span>
          Your 3D model has been reviewed and received a verification score. This score measures the
          quality of your model, with a higher score indicating more successful standard checks. The date
          of verification is displayed below the score. You can now re-upload your model after making changes
          and track how it affects the score. On the model page, you can see the specific factors that
          contribute to your model&apos;s score. Please note that if the model has multiple files the
          best-performing file score will be shown.
        </span>
      )
    } else {
      return (
        <span>
          Your model is currently in the &quot;N/A&quot; status. Please note that our team can only check certain
          file formats, and we cannot guarantee that every model will be reviewed. If we are able to review
          your model, the status will change accordingly. Please do not attempt to expedite the process, as
          all models are reviewed in the order in which they are received. You can check the list of supported
          file formats <a href="https://help.cgtrader.com/hc/en-us/articles/14118757652881-Files-requirements" target="_blank" rel="noopener noreferrer">here</a>.
        </span>
      )
    }
  }

  return (
    <div className="verification">
      <Tooltip
        id={`verification-tooltip-${id}`}
        place="top"
        clickable
        isAdjustable
        className={!hasVerified ? 'verification-popover-container' : ''}
        tooltipClassName="verification__progress"
        content={(
          <span className="verification__text">
            {tooltipText}
          </span>
        )}
      >
        {hasVerified && !printReady
          ? <Progress progress={cgtVerificationPercentage} showPercentage />
          : <Icon svgComponent={AttentionOutlined} color="dark" notSpaced />
        }
      </Tooltip>

      {(printReady || pendingVerification) ? 'N/A' : !hasVerified ? 'Processing failed' : null}

      {cgtVerificationAt && !printReady && (
        <span className="text-tiny">
          {moment(cgtVerificationAt).format('YYYY.MM.DD')}
        </span>
      )}
    </div>
  )
}

Verification.propTypes = {
  column: object,
}

export default Verification
